;(() => {
  const isMobile = $("html").hasClass("mobile")
  const $body = $("body")

  const colorFlash = (anchorId) => {
    const $anchor = $(anchorId)
    $anchor.removeClass("anchor_active")
    requestAnimationFrame(() => {
      $anchor.addClass("anchor_active")
    })
  }

  const scroll = (anchorId) => {
    if (!isMobile && decodeURI(location.hash) !== anchorId) {
      history.pushState(null, null, anchorId)
    }
    Viewport.scrollTo($(anchorId), {
      offset: 0,
      callback: () => {
        colorFlash(anchorId)
        if (isMobile) {
          // same in room-link.js
          $body.one("fixedBelowHFF:off", () => {
            $body.removeClass("body_to-intro")
          })
        }
      },
    })
  }

  const scrollWithinSection = (event, sectionSelector, anchorId) => {
    event.preventDefault()

    if (isMobile) {
      // same in room-link.js
      $body.addClass("body_to-intro")
    }

    let resolvedAnchorId = anchorId
    const $anchor = $(anchorId)
    if ($anchor.length < 1) {
      const anchorIdBeginning = anchorId.replace(/__.+/, "__")
      resolvedAnchorId = $(`.anchor--link[href^='${anchorIdBeginning}']`).attr(
        "href",
      )
    }

    const $container = $(sectionSelector)
    const isOpened = $container.attr("class").includes("_opened") || !isMobile
    if (isOpened) {
      scroll(resolvedAnchorId)
    } else {
      $container.one("transitionend", () => {
        scroll(resolvedAnchorId)
      })
      $container.children(".toggle--title").trigger("click")
    }
  }

  $(document).on("click", "a.anchor--link", (event) => {
    Activity.track("leisure-summary", event.target.dataset.feature)
    if (document.body.classList.contains("show-registration-wall")) {
      event.preventDefault()
      Viewport.scrollTo($(".registration-wall"), { offset: 0, speed: 500 })
      return
    }

    const href = $(event.currentTarget).attr("href")
    if (href.includes("PropertyBeach")) {
      scrollWithinSection(event, "#beaches", href)
      return
    }
    if (href.includes("PropertyPool")) {
      scrollWithinSection(event, "#pools", href)
      return
    }
    if (href.includes("PropertyWellnessCenter")) {
      scrollWithinSection(event, "#wellness", href)
    }
  })
})()
